module.exports = __webpack_public_path__ + "img/slim.8a077197.png";